import { Typography } from '@mui/material';

export const Footer = ({ children }) => (
  <Typography variant="h6" component="h2" textAlign="center">
    {children}
  </Typography>
);
